import { BaseService } from './base.service';

export interface NBAResponseItem {
  actionType: string;
  ctaType: string;
  ctaLabel: string;
  summary: string;
  priority: number;
  metadata?: {
    prescriptionId?: string;
    documentId?: string;
  };
}

export interface InsightsResponse {
  success: boolean;
  data: NBAResponseItem[];
  message?: string;
}

class InsightsService extends BaseService {
  constructor() {
    super('/nba');
  }

  async getNextBestActions(): Promise<NBAResponseItem[]> {
    const response = await this.get<any>('/next-best-actions');
    
    // The API seems to return the array directly, not wrapped in a data property
    let result: NBAResponseItem[] = [];
    if (Array.isArray(response)) {
      result = response;
    } else if (response?.data && Array.isArray(response.data)) {
      result = response.data;
    }
    return result;
  }
}

export const insightsService = new InsightsService();
export default insightsService;
